import { Add } from "@payping/icons";
import { Button } from "@payping/web-components";
import { FC } from "react";
import { useAppTranslation } from "@/utils/useAppTranslation";

interface Props {
  showModal: () => void;
}

export const TokenListEmpty: FC<Props> = (props) => {
  const { showModal } = props;
  const { t } = useAppTranslation();

  return (
    <Button type={"primary"} icon={<Add width={14} height={14} />} onClick={() => showModal()}>
      {t("token.addToken")}
    </Button>
  );
};
